import { useSelector } from 'react-redux';
import * as BuyIntentionSelectors from 'store/state/buyIntention/buyIntenteionSelectors';
import BuyIntentionItems from '../List/BuyIntentionItems';

export default function Step02Resume() {
  const tableData = useSelector(BuyIntentionSelectors.getOverviewEdit);
  return (
    <div key="1">
      <BuyIntentionItems tableData={tableData} />
    </div>
  );
}
